/**
 * moderateMessage — fire-and-forget call into the moderate-message
 * edge function. RAELA Function 1 is always-on globally (V2 §13);
 * admins can tune sensitivity per room or per user via monitoring
 * mode (off / standard / strict / shadow). The send path NEVER awaits
 * this — moderation is a server-side post-process that updates the row
 * in place; the realtime subscription will deliver the flagged update.
 */
import { supabase } from "@/integrations/supabase/client";

export type ModerationSurface = "dm" | "community" | "raela";

export const moderateMessage = (
  surface: ModerationSurface,
  messageId: string,
  body: string,
  opts: { roomId?: string | null } = {},
): void => {
  // Only meaningful text is worth classifying.
  if (!body || body.trim().length === 0) return;
  void supabase.functions
    .invoke("moderate-message", {
      body: {
        surface,
        message_id: messageId,
        body,
        room_id: opts.roomId ?? null,
      },
    })
    .catch(() => {
      /* fail-open per spec — never block the send */
    });
};
